module.exports = __webpack_public_path__ + "img/arrow.54717a8b.svg";